
export default {
  name: 'LoginCard',
  props: {
    verbiages: {
      type: Object,
      default: () => ({
        title: '',
        subtitle: ''
      })
    },
    isHtml: Boolean,
    isBackButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isNotSmallScreen() {
      return !this.$vuetify.breakpoint.smAndDown
    }
  }
}
